<template>
  <div class="header w">
    <div class="logo" @click="setActiveTab('home')">
      <img class="images" src="../assets/img/yiren/logo.png" alt="">
    </div>
    <div class="contont">
      <div :class="['home', { 'active': saveHigh === 'home' }]" @click="setActiveTab('home')">首页</div>
      <div :class="['AboutUs', { 'active': saveHigh === 'AboutUs' }]" @click="setActiveTab('AboutUs')">艺人库</div>
      <div :class="['case', { 'active': saveHigh === 'case' }]" @click="setActiveTab('case')">院校专区</div>
      <div :class="['information', { 'active': saveHigh === 'information' }]" @click="setActiveTab('information')">艺考机构
      </div>
    </div>
    <div class="search">
      <el-input v-model="input" placeholder="请输入关键词" style="border: none; outline: none;" @input="handleInput">
        <i slot="prefix" class="el-input__icon el-icon-search"></i></el-input>
    </div>
    <div class="logins" @click="login" v-if="!isShow">
      登录/注册
    </div>
    <div class="logins" @click="logOut" v-else>
      退出登录
    </div>
  </div>
</template>

<script>
// import moreproducturl from "../assets/img/dulles/测试下拉产品.jpg";
import { baseURL } from "../utils/index.js";
// eslint-disable-next-line
import { mapGetters, mapActions } from 'vuex';
export default {
  name: "Header",
  components: {},
  data() {
    return {
      input: '',
      timeoutId: null,
      isShow: false
    };
  },

  created() { },
  computed: {
    ...mapGetters([
      'saveHigh'
    ])
  },
  mounted() {
    this.syncActiveTab()
    if (localStorage.getItem('token')) {
      this.isShow = true
    }else{
      this.isShow = false
    }
  },
  watch: {
    '$route'(to) {
      // 路由变化时同步输入状态
      if (to.name !== 'AboutUs') {
        this.input = ''
      } else {
        this.input = to.query.keyword || ''
      }
      // 添加路由变化时同步选中状态
      this.syncActiveTab()
    }
  },
  methods: {
    ...mapActions([
      'setSaveHigh',
      'setSaveCondition'
    ]),
    syncActiveTab() {
      const routeName = this.$route.name
      if (['home', 'AboutUs', 'case', 'information'].includes(routeName)) {
        this.setSaveHigh(routeName)
      }
    },
    handleInput() {
      clearTimeout(this.timeoutId)
      this.timeoutId = setTimeout(() => {
        this.handleSearch()
      }, 500)
    },
    // 处理搜索跳转
    // handleSearch() {
    //   // 如果已经在当前页面且关键词相同则不重复跳转
    //   // if (this.$route.name === 'AboutUs' &&
    //   //   this.$route.query.keyword === this.input) return
    //   if (this.input) {
    //     this.setSaveHigh('AboutUs')
    //     const route = {
    //       name: 'AboutUs',
    //       query: { ...this.$route.query, keyword: this.input }
    //     }
    //     // 判断是否在当前页面
    //     this.$route.name === 'AboutUs'
    //       ? this.$router.replace(route)
    //       : this.$router.push(route)
    //   }
    // },
    handleSearch() {
      // 获取规范化后的关键词
      const currentKeyword = this.$route.query.keyword || ''
      const newKeyword = this.input.trim()

      // 关键词未发生变化时不执行操作
      if (currentKeyword === newKeyword) return

      // 构建新的query对象
      const newQuery = { ...this.$route.query }
      newKeyword ? (newQuery.keyword = newKeyword) : delete newQuery.keyword

      // 执行路由导航
      const navigate = () => {
        const routeConfig = { name: 'AboutUs', query: newQuery }
        this.setSaveHigh('AboutUs')
        this.$route.name === 'AboutUs'
          ? this.$router.replace(routeConfig)
          : this.$router.push(routeConfig)
      }

      // 特殊处理从有值到空的情况
      if (!newKeyword && currentKeyword) {
        navigate()
      } else if (newKeyword) {
        navigate()
      }
    },
    // 获取图片路径-拼接地址
    getImageURL(image) {
      return baseURL + image;
    },
    // 点击跳转页面
    setActiveTab(tab) {
      // 切换页面时清除输入
      if (tab !== 'AboutUs') {
        this.input = ''
        this.setSaveCondition({})
      }
      this.setSaveHigh(tab)
      this.$router.push({ name: tab })
    },
    login() {
      this.$router.push({ name: 'Login' })
    },
    logOut() {
      localStorage.removeItem('token')
      this.isShow = false
      this.$router.push({ name: 'home' })
      this.$message({
        message: "退出成功",
        type: "success"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  position: relative;
  padding: 9px 0;
  display: flex;
  align-items: center;

  .logo {
    width: 168px;
    cursor: pointer;

    .images {
      width: 168px;
    }
  }

  .contont {
    margin: 0px 223px 0 118px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;


    .home,
    .AboutUs,
    .case,
    .information,
    .contactUs {
      margin-right: 60px;
      cursor: pointer;
      position: relative;
      color: #999999;
      font-weight: 600;

      &.active {
        color: #292929; // 文字颜色改为蓝色

        &::after {
          content: '';
          position: absolute;
          left: 50%;
          bottom: -29px; // 横线位置
          transform: translateX(-50%);
          width: 50px;
          height: 1px;
          border-radius: 30px;
          background-color: #292929; // 横线颜色
        }
      }
    }
  }

  .search {
    margin-right: 30px;

    ::v-deep .el-input__inner {
      border: none;
      background: #F3F3F3;
    }
  }

  .logins {
    border: 1px solid #333333;
    border-radius: 6px;
    color: #333333;
    font-size: 16px;
    padding: 10px 13px;
    cursor: pointer;
  }

  .conmsult {
    font-size: 14px;
    color: #FFFFFF;
    background-color: #2152FF;
    padding: 10px 26px;
    border-radius: 10px;
    cursor: pointer;
  }
}
</style>
